








import { defineComponent } from '@vue/composition-api';

const CommonIconTop = defineComponent({
  // setup() {},
  props: {
    title: {
      type: [String, Number],
    },
    subtitle: {
      type: [String, Number],
    },
    label: {
      type: String,
    },
    icon: {
      type: String,
    },
    width: {
      type: String,
      default: '6',
    },
    titleSize: {
      type: String,
      default: 'xl',
    },
    subTitleSize: {
      type: String,
      default: 'md',
    },
    iconClass: { default: 'w-8 h-8' },
    iconColor: { default: 'primary' },
  },
});

export default CommonIconTop;
